<template>
    <button
        type="button"
        class="o-search-button-otg"
        @click="onClick"
        :style="componentStyles"
    >
        <span class="search-button-otg-text">
            <svg-icon
                v-if="isShowBackIcon"
                original
                name="icons/arrow-left-transparent"
                class="search-button-back-button"
            />
            <span class="search-button-otg-text-highlight">{{ backText }}</span>
            {{ objectName }}
        </span>
    </button>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from '../../../utils/helpers/capitalize'
export default {
    name: 'OSearchButtonOtg',
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getDenormalisedObjectById',
        ]),
        destinationObjectId(){
            return Number(this.$route.query.t || this.$route.query.mTo);
        },
        destinationObject() {
            return this.getDenormalisedObjectById(this.destinationObjectId) || { id: '' };
        },
        objectName() {
            return capitalize(this.t(this.destinationObject, 'name'));
        },
        componentStyles() {
            return this.getMapConfigProp('components.OSearchButtonOtg.styles') || {};
        },
        componentParams() {
            return this.getMapConfigProp('components.OSearchButtonOtg.params') || {};
        },
        isShowBackIcon() {
            return this.componentParams.is_show_back_icon
        },
        backText() {
            if(this.componentParams.back_text) {
                return this.$t(this.componentParams.back_text)
            }

            return this.$t('ui.to')
        }
    },
    setup(props, { emit }) {
        function onClick() {
            emit('onClick');
        }

        return {
            onClick
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />